import { render, staticRenderFns } from "./myTlentInfo.vue?vue&type=template&id=ea84c982&scoped=true"
import script from "./myTlentInfo.vue?vue&type=script&lang=js"
export * from "./myTlentInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea84c982",
  null
  
)

export default component.exports